import DataTable from 'react-data-table-component';

import EmptyState from './EmptyState';

import { customStyles, pageOptions } from '../../utils/pageStyles';
import getSkuColumn from './Columns/getSkuColumn';
import getProductNameColumn from './Columns/getProductNameColumn';
import getPriceColumn from './Columns/getPriceColumn';
import getPublishedStatusColumn from './Columns/getPublishedStatusColumn';
import getVariantsDetailsLinkColumn from './Columns/getVariantsDetailsLinkColumn';
import getProductOptionsColumns from './Columns/getProductOptionsColumns';

export const VariantsTable = ({
  product,
  setVariant,
  token,
  vendorHasManagedStock,
}) => {
  const tableData = product?.variants || '';

  const productNameColum = getProductNameColumn(product.name);
  const priceColumn = getPriceColumn(product.full_price);
  const publishedStatusColumn = getPublishedStatusColumn({
    productStatus: product.status,
    token,
    setVariant,
  });

  const start = [getSkuColumn, productNameColum];
  const end = vendorHasManagedStock
    ? [priceColumn]
    : [priceColumn, publishedStatusColumn];

  if (product.variants.length > 1) {
    end.push(getVariantsDetailsLinkColumn);
  }

  const productOptions =
    product.options.length > 1 ? getProductOptionsColumns(product.options) : [];

  const columns = [...start, ...productOptions, ...end];

  return (
    <div>
      <div className="row border-top pt-4">
        <div className="col-12 col-lg-6">
          <p className="text-secondary fw-light pr-4 fs-4">
            Confira as opções deste produto que os lojistas podem solicitar
            quando compram na Inventa:
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <DataTable
            columns={columns}
            data={tableData}
            pagination
            noDataComponent={<EmptyState tableData />}
            customStyles={customStyles}
            paginationComponentOptions={pageOptions}
            fixedHeader
            fixedHeaderScrollHeight="600px"
          />
        </div>
      </div>
    </div>
  );
};
